/** Support cases routes (§11.4, §16.2 "support-case linkage"). */
import type { ConsoleRoute } from '../index';
import { SupportCaseDetailPage } from './SupportCaseDetailPage';
import { SupportQueuePage } from './SupportQueuePage';

export const supportRoutes: ConsoleRoute[] = [
  {
    path: 'support',
    handle: { permission: 'claims.view', title: 'Support cases' },
    element: <SupportQueuePage />,
  },
  {
    path: 'support/:id',
    handle: { permission: 'claims.view', title: 'Support case' },
    element: <SupportCaseDetailPage />,
  },
];
